import { render } from "./PluginViews.vue?vue&type=template&id=2c87cb12"
import script from "./PluginViews.vue?vue&type=script&lang=js"
export * from "./PluginViews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__